import cx from 'classnames';
import {useState} from 'react';
import { format, getWeek, sub, add, startOfWeek, endOfWeek } from 'date-fns';
import { useEffect } from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { endpoint } from "./config";
import axios from "axios";
import Select from 'react-select';


function Approval() {
  const [projects] = useState([]);
  const [managers] = useState([]);
  const [reload, setReload] = useState(false);

  const [weeks, setWeeks] = useState([]);
  const [calenderDate, setCalendarDate] = useState(startOfWeek(new Date()));
  const [activeWeekNo, setActiveWeekNo] = useState(format(calenderDate, "yyyy/") + getWeek(calenderDate, { weekStartsOn: 0 }), );
  const [activeWeek, setActiveWeek] = useState({"startDate":format(startOfWeek(calenderDate), "yyyy-MM-dd"), "endDate": format(endOfWeek(calenderDate), "yyyy-MM-dd")});
  const [activeFilter, setActiveFilter] = useState(["Open"]);
  const [filterProject, setFilterProject] = useState(null);
  const [filterManager, setFilterManager] = useState(null);
  const [filterEmployee, setfilterEmployee] = useState("");
  const [rawData, setRawData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [count, setCount] = useState({total: 0, filteredTotal: 0, open:0, submitted: 0, approval: 0, posted: 0, returned: 0});


  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      //borderColor: state.isFocused ? 'grey':'red',
      height: 33,
      minHeight: 33,
    }),
    valueContainer: (base)=>({
      ...base,
      paddingTop: 0,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      marginTop: "5px",
      marginBottom: "8px",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 33,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const prevWeek = () => {
    setCalendarDate(sub(calenderDate, {weeks: 1}));
  }

  const nextWeek = () =>{
    setCalendarDate(add(calenderDate, {weeks: 1}));
  }

  useEffect(()=>{
    console.log("Calender Date", format(calenderDate, "yyyy-MM-dd"));

    let preWeek1  = sub(calenderDate, {weeks: 2});
    let preWeek2  = sub(calenderDate, {weeks: 1});
    let currWeek  = calenderDate;
    let nextWeek1 = add(calenderDate, {weeks: 1});
    let nextWeek2 = add(calenderDate, {weeks: 2});

    let startWeek1 = startOfWeek(preWeek1);
    let startWeek2 = startOfWeek(preWeek2);
    let startWeek3 = startOfWeek(currWeek);
    let startWeek4 = startOfWeek(nextWeek1);
    let startWeek5 = startOfWeek(nextWeek2);

    let endWeek1 = endOfWeek(preWeek1);
    let endWeek2 = endOfWeek(preWeek2);
    let endWeek3 = endOfWeek(currWeek);
    let endWeek4 = endOfWeek(nextWeek1);
    let endWeek5 = endOfWeek(nextWeek2);

    //const weekNo = getWeek(value, { weekStartsOn: 0 });
    const currentWeekNo = format(new Date(), "yyyy/") + getWeek(new Date(), { weekStartsOn: 0 });

    let tempArray = [
      { weekNo: format(startWeek1, "yyyy/") + getWeek(startWeek1, { weekStartsOn: 0 }), weekStart: startWeek1, weekEnd: endWeek1, format: formatWeek(startWeek1, endWeek1), status: "Open", current: format(startWeek1, "yyyy/") + getWeek(startWeek1, { weekStartsOn: 0 })===currentWeekNo },
      { weekNo: format(startWeek2, "yyyy/") + getWeek(startWeek2, { weekStartsOn: 0 }), weekStart: startWeek2, weekEnd: endWeek2, format: formatWeek(startWeek2, endWeek2), status: "Open", current: format(startWeek2, "yyyy/") + getWeek(startWeek2, { weekStartsOn: 0 })===currentWeekNo },
      { weekNo: format(startWeek3, "yyyy/") + getWeek(startWeek3, { weekStartsOn: 0 }), weekStart: startWeek3, weekEnd: endWeek3, format: formatWeek(startWeek3, endWeek3), status: "Open", current: format(startWeek3, "yyyy/") + getWeek(startWeek3, { weekStartsOn: 0 })===currentWeekNo },
      { weekNo: format(startWeek4, "yyyy/") + getWeek(startWeek4, { weekStartsOn: 0 }), weekStart: startWeek4, weekEnd: endWeek4, format: formatWeek(startWeek4, endWeek4), status: "Open", current: format(startWeek4, "yyyy/") + getWeek(startWeek4, { weekStartsOn: 0 })===currentWeekNo },
      { weekNo: format(startWeek5, "yyyy/") + getWeek(startWeek5, { weekStartsOn: 0 }), weekStart: startWeek5, weekEnd: endWeek5, format: formatWeek(startWeek5, endWeek5), status: "Open", current: format(startWeek5, "yyyy/") + getWeek(startWeek5, { weekStartsOn: 0 })===currentWeekNo },
    ];
    setWeeks(tempArray);
    console.log(tempArray);

  }, [calenderDate]);

  useEffect(()=>{
    async function asynFn(){
      const [projectsArray, managersArray] = await axios.all([getProjects(), getManagers()]);

      projectsArray.forEach(row=>{
        projects.push({value: row.projectName, label: row.projectName});
      })
      managersArray.forEach(row=>{
        managers.push({value: row.manager, label: row.manager});
      })
    }
    const getManagers = async () => {
      try{
        const response = await axios.get(
          `${endpoint}/managers`
        );
        return response.data.data;
  
      }catch(err){
        console.log('getManagers', err.message);
      }
    }
    const getProjects = async () => {
      try{
        const response = await axios.get(
          `${endpoint}/projects`
        );
        return response.data.data;
  
      }catch(err){
        console.log('getProjects', err.message);
      }
    }

    asynFn();
  }, [projects, managers]);

  useEffect(()=>{
    async function asynFn(){
      const [tempRawData] = await axios.all([fetchDetailedReport()]);
      //console.log(tempRawData);
      setRawData(tempRawData);
    }
    const fetchDetailedReport = async () => {
      try{
        const response = await axios.get(
          `${endpoint}/approvalDetails/${activeWeek.startDate}/${activeWeek.endDate}`
        );
        return response.data.data;
  
      }catch(err){
        console.log('getDetailedReport', err.message);
      }
    }

    asynFn();
  }, [activeWeek, reload]);

  useEffect(()=>{
    console.log("raw data changed filter apply", filterProject && filterProject['value'], filterManager && filterManager['value']);
    setTotalRecords(rawData.length);
    let tempArray = [...rawData];

    if (filterProject){
      tempArray = tempArray.filter(element=>element.projectName===filterProject['value']);
      //const tempFilter = tempArray.filter(element=>element.projectName===filterProject['value']);
      //setFilteredData(tempFilter);
      //console.log('filter applied for project', tempFilter);
    }else{
      //setFilteredData(rawData);
    }
    if (filterManager){
      tempArray = tempArray.filter(element=>element.manager===filterManager['value']);
      //setFilteredData(rawData.filter(element=>element.manager===filterManager['value']));
    }

    if (tempArray){
      if (filterEmployee){
        tempArray = tempArray.filter(element => element.employeeName.toLowerCase().includes(filterEmployee.toLowerCase()));
        //console.log("filterEmployee", tempData);
        //setFilteredData(tempData);
      }
      
    }
    setFilteredData(tempArray);

    if (tempArray) {
      let filterArray = [];
      
      activeFilter.forEach(status=>{
        if (status==="Open"){
          filterArray = [...filterArray, tempArray.filter(element=>element.submitted===0)];
        }else if (status==="Submitted"){
          filterArray = [...filterArray, tempArray.filter(element=>element.submitted===1 && element.approved===0)];
        }else if (status==="Approved"){
          filterArray = [...filterArray, tempArray.filter(element=>element.approved===1)];
        }else if (status==="Posted"){
          filterArray = [...filterArray, tempArray.filter(element=>element.approved===4)];
        }else if (status==="Returned"){
          filterArray = [...filterArray, tempArray.filter(element=>element.approved===2 || element.approved===3)];//Rejected or Rejected
        }
      });
      //Convert multidimensional array into object array
      filterArray = [].concat.apply([], filterArray);
      
      setData(filterArray);
    }

  }, [rawData, activeFilter, filterProject, filterManager, filterEmployee]);

  useEffect(()=>{
    let open = 0, submitted = 0, approved = 0, posted = 0, returned = 0;
    console.log("filteredData changed, count", filteredData);

    if (filteredData){      

      filteredData.forEach(element => {
          if (element.submitted===0){
            open++;
          }else if(element.approved===1){
            approved++;
          }else if(element.approved===2 || element.approved===3){//Rejected or Rejected
            returned++;
          }else if(element.approved===4){//Posted
            posted++;
          }else if(element.submitted===1){
            submitted++;
          }
        });
        setCount({filteredTotal: filteredData.length, open: open, submitted: submitted, approved: approved, posted: posted, returned:returned});
    }
    
  }, [filteredData]);


  useEffect(()=>{
    /*
    if (filteredData){
      if (activeFilter==="Open"){
        setData(filteredData.filter(element=>element.submitted===0));
      }else if (activeFilter==="Submitted"){
        setData(filteredData.filter(element=>element.submitted===1 && element.approved!==1));
      }else if (activeFilter==="Approved"){
        setData(filteredData.filter(element=>element.approved===1));
      }else{
        setData([]);
      }
    }
    */
  }, [activeFilter, filteredData]);

  useEffect(()=>{
    /*
    if (rawData){
      if (filterEmployee){
        const tempData = rawData.filter(element => element.employeeName.toLowerCase().includes(filterEmployee.toLowerCase()));
        console.log("filterEmployee", tempData);
        setFilteredData(tempData);
      }else{
        setFilteredData(rawData);
      }
      
    }*/
  }, [filterEmployee, rawData]);

  const btnApproveWeek = async (employeeId, weekNo) => {
    let params = new FormData();
    params.append("employeeId", employeeId);
    params.append("weekNo", weekNo);

    const response = await axios.post(`${endpoint}/week/approve`, params);
    const data = response.data;
    //console.log(data);
    if (data.status) {
      //toast(`Week #${weekNo} has submitted successfully.`);
      //setSubmitted(true);
      setReload(!reload);
    } else {
      console.log(data.message);
    }
  };
  const btnRejectWeek = async (employeeId, weekNo) => {
    let params = new FormData();
    params.append("employeeId", employeeId);
    params.append("weekNo", weekNo);

    const response = await axios.post(`${endpoint}/week/reject`, params);
    const data = response.data;
    //console.log(data);
    if (data.status) {
      //toast(`Week #${weekNo} has submitted successfully.`);
      //setSubmitted(true);
      setReload(!reload);
    } else {
      console.log(data.message);
    }
  };
  const btnReturnWeek = async (employeeId, weekNo) => {
    let params = new FormData();
    params.append("employeeId", employeeId);
    params.append("weekNo", weekNo);

    const response = await axios.post(`${endpoint}/week/return`, params);
    const data = response.data;
    //console.log(data);
    if (data.status) {
      //toast(`Week #${weekNo} has submitted successfully.`);
      //setSubmitted(true);
      setReload(!reload);
    } else {
      console.log(data.message);
    }
  };


  const toggleFilter = (filterName) => {
    console.log(filterName);
    if (activeFilter.indexOf(filterName) >=0){
      setActiveFilter(activeFilter.filter(element=>element!==filterName));
    }else{
      setActiveFilter([...activeFilter, filterName]);
    }
  }

  const formatWeek = (startDate, endDate) => {
    if (format(startDate, "MM")===format(endDate, "MM")){
      return format(startDate, "dd") + " - " + format(endDate, "dd MMMM");
    }else{
      return format(startDate, "dd MMMM") + " - " + format(endDate, "dd MMMM");
    }
  }
  
  return (
    <>
      <header className="page-title-bar">
        <h1 className="page-title mr-sm-auto mb-0"> Approval </h1>
      </header>

      <div className="flex justify-center align-center mb-3">
        <div className="btn-group flex">
          <button type="button" className="btn btn-secondary wd-50 mr-1" onClick={prevWeek}>
            &lt;
          </button>
          {
            //.sort((a, b) => new Date(b.weekStart) - new Date(a.weekStart) )
            weeks.map((elementWeek, index) => {
              return (
                <button
                  key={index}
                  type="button"
                  className={cx(
                    "btn btn-secondary mr-1",
                    elementWeek.current && "current",
                    elementWeek.weekNo === activeWeekNo && "active"
                  )}
                  onClick={() => {
                    setActiveWeekNo(elementWeek.weekNo);
                    setActiveWeek({
                      startDate: format(elementWeek.weekStart, "yyyy-MM-dd"),
                      endDate: format(elementWeek.weekEnd, "yyyy-MM-dd"),
                    });
                  }}
                >
                  <div className="flex flex-column">
                    <span>
                    {
                      (format(elementWeek.weekStart, "MM")===format(elementWeek.weekEnd, "MM")) ? 
                        format(elementWeek.weekStart, "dd") + " - " + format(elementWeek.weekEnd, "dd MMMM"):
                      format(elementWeek.weekStart, "dd MMMM") + " - " + format(elementWeek.weekEnd, "dd MMMM")
                    }</span>
                    {//formatWeek(elementWeek.weekStart, elementWeek.weekEnd)
                    }
                    <span className='d-none'>{format(elementWeek.weekStart, "yyyy-MM-dd")}</span>
                    <span>{elementWeek.status}</span>
                  </div>
                </button>
              );
            })
          }
          <button type="button" className="btn btn-secondary wd-50" onClick={nextWeek}>
            &gt;
          </button>
        </div>
      </div>

      <div className="card" style={{ marginBottom: "60px" }}>
        <div className="card-body">
          <div className="filter-header mb-2">
            <div className="header-left">
              <div className="flex mr-2 align-center">
                <label className="mr-1 fontweight-500">Project</label>
                <Select
                  className="wd-200"
                  styles={customSelectStyles}
                  value={filterProject}
                  options={projects}
                  isClearable={true}
                  onChange={(inputValue) => {
                    setFilterProject(inputValue);
                  }}
                />
              </div>

              <div className="flex mr-2 align-center">
                <label className="mr-1">Resource Manager</label>
                <Select
                  className="wd-250"
                  styles={customSelectStyles}
                  value={filterManager}
                  options={managers}
                  isClearable={true}
                  onChange={(inputValue) => {
                    setFilterManager(inputValue);
                  }}
                />
              </div>
            </div>
            <div className="header-right">
              <div className="pagination mr-2">
                {count.filteredTotal}/{totalRecords} Members
              </div>
              <div className="controls">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setFilterManager(null);
                    setFilterProject(null);
                  }}
                >
                  Show All
                </button>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-6">
            <div className="cell head">
              <input
                type="text"
                className="form-control"
                name="search"
                placeholder="Search Emp"
                value={filterEmployee}
                onChange={(event) => setfilterEmployee(event.currentTarget.value)}
              ></input>
            </div>
            <div className="cell head">
              <button
                className={cx("btn btn-filter wd-100p", activeFilter.indexOf("Open")>=0 && "active")}
                onClick={()=>toggleFilter("Open")}
              >
                <div className="count">{count.open}</div> <div className="caption">Open</div>
              </button>
            </div>
            <div className="cell head">
              <button
                className={cx("btn btn-filter wd-100p", activeFilter.indexOf("Submitted")>=0 && "active")}
                onClick={()=>toggleFilter("Submitted")}
              >
                <div className="count">{count.submitted}</div> <div className="caption">Submitted</div>
              </button>
            </div>
            <div className="cell head">
              <button
                className={cx("btn btn-filter wd-100p", activeFilter.indexOf("Approved")>=0 && "active")}
                onClick={()=>toggleFilter("Approved")}
              >
                <div className="count">{count.approved}</div> <div className="caption">Approved</div>
              </button>
            </div>
            <div className="cell head">
              <button
                className={cx("btn btn-filter wd-100p", activeFilter.indexOf("Posted")>=0 && "active")}
                onClick={()=>toggleFilter("Posted")}
              >
                <div className="count">{count.posted}</div> <div className="caption">Posted</div>
              </button>
            </div>
            <div className="cell head">
              <button
                className={cx("btn btn-filter wd-100p", activeFilter.indexOf("Returned")>=0 && "active")}
                onClick={()=>toggleFilter("Returned")}
              >
                <div className="count">{count.returned}</div> <div className="caption">Rejected</div>
              </button>
            </div>
          </div>
          {data.map((element, index) => {
            return (
              <div key={index} className="grid grid-cols-6">
                <div className="cell flex">
                  <div className="text-center">
                    <div>{element.employeeName}</div>
                    <div>{element.designation}</div>
                  </div>
                  <div className="hours">{element.submittedHours}/40</div>
                </div>
                <div className="cell">
                  {element.submitted === 0 && (
                    <div className="">
                      <button type="button" className="btn-icon mr-1" title='Notify user to submit'>
                        <FontAwesomeIcon icon={"bell"} color="#2b4890" className="btn-icon-wrapper" />
                      </button>
                    </div>
                  )}
                </div>
                <div className="cell">
                  {element.submitted === 1 && element.approved === 0 && (
                    <div className="">
                      <button type="button" className="btn-icon mr-1" title="Click to approve">
                        <FontAwesomeIcon
                          icon={"thumbs-up"}
                          color="#4caf50"
                          className="btn-icon-wrapper"
                          onClick={() => btnApproveWeek(element.employeeId, element.weekNo)}
                        />
                      </button>
                      <button
                        type="button"
                        className="btn-icon"
                        title="Click to reject"
                        onClick={() => btnRejectWeek(element.employeeId, element.weekNo)}
                      >
                        <FontAwesomeIcon icon={"thumbs-down"} color="red" className="btn-icon-wrapper" />
                      </button>
                    </div>
                  )}
                </div>
                <div className="cell">
                  {element.approved === 1 && (
                    <div className="">
                      <button
                        type="button"
                        className="btn-icon"
                        title="Click to reject"
                        onClick={() => btnRejectWeek(element.employeeId, element.weekNo)}
                      >
                        <FontAwesomeIcon icon={"thumbs-down"} color="red" className="btn-icon-wrapper" />
                      </button>
                    </div>
                  )}
                </div>
                <div className="cell">{//Posted Section
                }</div>
                <div className="cell">
                  {(element.approved === 2 || element.approved === 3) && (//Rejected or Returned
                    <div className="">
                      <button
                        type="button"
                        className="btn-icon"
                        title="Click to approve again"
                        onClick={() => btnApproveWeek(element.employeeId, element.weekNo)}
                      >
                        <FontAwesomeIcon icon={"thumbs-up"} color="#4caf50" className="btn-icon-wrapper" />
                      </button>
                      <button
                        type="button"
                        className="btn-icon"
                        title={element.approved === 3 ? 'Already returned to user':'Return to user'}
                        onClick={() => btnReturnWeek(element.employeeId, element.weekNo)}
                        disabled={element.approved === 3}//3 = returned
                      >
                        <FontAwesomeIcon icon={"reply"} color={cx({"#f1c40f" : element.approved === 2})} className="btn-icon-wrapper" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          <div className="grid grid-cols-6 d-none">
            <div className="cell flex">
              <div className="text-center">
                <div>Patralekh Satyam</div>
                <div>Engineer 2</div>
              </div>
              <div className="hours">16/40</div>
            </div>

            <div className="cell"></div>
            <div className="cell">
              <div className="">
                <button type="button" className="btn-icon mr-1">
                  <FontAwesomeIcon icon={"thumbs-up"} color="orange" className="btn-icon-wrapper" />
                </button>
                <button type="button" className="btn-icon">
                  <FontAwesomeIcon icon={"thumbs-down"} color="red" className="btn-icon-wrapper" />
                </button>
              </div>
            </div>
            <div className="cell"></div>
            <div className="cell"></div>
            <div className="cell"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Approval;
